import { Loadable } from '..';

export interface UserSetting {
  name: string;
  settingValue: any;
}

export interface UserSettings {
  userId: string;
  accountId?: number;
  companyId?: number;
  simGroupId?: string;
  userSettings: Array<UserSetting>;
}

export type UserSettingsState = Loadable<UserSettings>;

export const getDefaultUserSettingsState = (): UserSettingsState => {
  return {
    userId: '',
    userSettings: [],
    isLoading: false,
  };
};
